export enum Routes {
    AppHome = '*',
  }
  